(() => {
  'use strict';
  if (customElements.get('bm-nano-configurator')) return;
  // Generated from catalog/en.json -- keep them hand-synced with the catalog.
  const EN_MESSAGES = {"choose_mount": "Choose your mount", "compare_mounts": "Compare mounts", "compare_mounts_title": "Which mount fits your rack?", "whats_in_box": "What's in the box", "whats_included": "See what's included", "slide_title": "Sliding Rack Mount", "fixed_title": "Fixed Rack Mount", "slide_fit": "Fits 75 × 75 mm uprights. Slides along the upright, no hole spacing needed.", "fixed_fit": "Fits 50 × 50 to 75 × 75 mm uprights, including 60 × 60 mm. Bolts through two holes.", "badge_preorder": "Pre-order", "badge_coming": "Coming soon", "coming_soon_button": "Coming soon", "measure_first": "Measure your upright and check the holes before you choose. Both mounts hold the same Gym Nano; only the way it attaches to the rack differs.", "row_upright": "Upright size", "row_hole": "Hole diameter", "row_spacing": "Hole spacing", "row_orientation": "Orientation", "row_adjust": "Height adjustment", "row_availability": "Availability", "spec_slide_upright": "75 × 75 mm (3 × 3 in)", "spec_fixed_upright": "50 × 50 mm to 75 × 75 mm, including 60 × 60 mm", "spec_hole": "15 mm (5/8 in) or larger", "spec_slide_spacing": "None required", "spec_fixed_spacing": "Two holes 50 mm apart, straight through the upright", "spec_slide_orientation": "90° to the machine", "spec_fixed_orientation": "0°, in line with the machine", "spec_slide_adjust": "Slides to any height on the upright", "spec_fixed_adjust": "Bolted at one height; move the bolts to change it", "rack_help": "Not sure? Send us your rack model and we will confirm the fit before you order.", "add_accessories": "Add your accessories", "selected_configuration": "Your selected configuration", "warranty": "2-year warranty", "subscription": "No mandatory subscription", "pack_benefit": "Includes Tricep Rope, Exercise Belt, Ankle Straps, Extension Strap and Bluetooth Ring", "included_with": "Included with {mount}", "included_count": "Included items: {count}", "item_nano": "Gym Nano", "item_nano_purpose": "The portable smart resistance unit: up to 100 kg of digital resistance, 5.1 m cable, 7-inch touchscreen, 8.2 kg.", "slide_box_item": "Sliding Rack Mount", "item_slide_purpose": "Clamps onto a 75 × 75 mm upright and slides to any height. Ships with every Sliding Rack Mount order.", "fixed_box_item": "Knob Quick-Release Rack Mount", "item_knob_purpose": "Bolts through two holes 50 mm apart on 50 × 50 to 75 × 75 mm uprights, including 60 × 60 mm. The knob releases the Gym Nano without tools.", "item_handle": "Handle for Gym Nano", "item_handle_purpose": "The standard cable handle for rows, presses, curls and pulls.", "item_case": "Travel Case", "item_case_purpose": "Padded case for carrying the Gym Nano and its accessories.", "item_clip": "Adapter Clip", "item_clip_purpose": "The quick-release clip on the cable end that takes the handle and every accessory.", "item_adapter": "65 W Power Adapter", "item_adapter_purpose": "Charges the built-in battery from a wall socket.", "item_cable": "USB-C Charging Cable (1.5 m)", "item_cable_purpose": "Connects the power adapter to the Gym Nano.", "item_protector": "Screen Protector", "item_protector_purpose": "Fitted over the touchscreen to guard against scratches.", "items_error": "Included item details could not load. Please refresh to try again.", "items_loading": "Loading included items…", "close_dialog": "Close", "previous_item": "Previous included item", "next_item": "Next included item", "select_item": "Select an item to see where it is", "product_photographs": "Product photographs", "enlarge_photo": "Enlarge product photograph", "choose_photo": "Choose a product photograph", "numbered_photo": "Product photograph {index}", "enlarged_photo": "Enlarged product photograph", "close_photo": "Close enlarged photograph", "selection_available": "{configuration}, {price}.", "selection_sold_out": "{configuration}, {price}, coming soon.", "choose_named_mount": "Choose {mount}", "selected_mount": "Selected mount", "adding": "Adding…", "save": "Save", "tax_included": "Tax included.", "tax_checkout": "Tax calculated at checkout.", "tax_including_rate": "Including {tax} at {rate}%.", "tax_excluding_checkout": "Excluding {tax}; added at checkout.", "tax_including_short": "Incl. {tax}", "tax_excluding_short": "Excl. {tax}", "tax_included_short": "Tax incl.", "tax_checkout_short": "Tax at checkout", "vat": "VAT", "extras_summary": "Accessories ({count}) · +{price} {basis}", "extras_compact": "+{price} · Accessories ({count})", "swiss_excluded": "Excluding Swiss {tax}.", "swiss_import_note": "Swiss import VAT (8.1%), customs-clearance fees and any applicable duties are not included in the price and are charged separately on delivery.", "qty_note": "{qty} x {price}", "dual_suffix": " x 2", "pack_summary": "The full attachment set for Gym Nano: five accessories that cover every cable movement the machine supports.", "pack_bullets": "Tricep Rope for pushdowns, curls and face pulls|Exercise Belt for hands-free squats, lunges and hip thrusts|Ankle Straps, a pair, for kickbacks and leg raises|Extension Strap to lengthen the cable for floor and overhead work|Bluetooth Ring to change resistance without reaching for the screen", "units_heading": "How many?", "units_one": "One unit", "units_two": "Two units", "units_note": "Two Gym Nano units in one order. Train both sides at once and track left and right separately."};
  const MOUNTS = {
    slide: { title: 'slide_title', fit: 'slide_fit', box: 'slide_box_item' },
    fixed: { title: 'fixed_title', fit: 'fixed_fit', box: 'fixed_box_item' }
  };
  const MOUNT_ORDER = ['slide', 'fixed'];
  const PACK_HANDLE = 'speediance-gym-nano-advanced-accessory-pack';
  // The only front-end quantity presets are one unit and the two-unit Dual.
  // This is the number that reaches /cart/add, so nothing else may get there.
  const MAX_QUANTITY = 2;
  const BOX_ICON = '<svg class="bmc-model__boxicon" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M21 8 12 3 3 8v8l9 5 9-5Z"/><path d="m3 8 9 5 9-5"/><path d="M12 13v8"/></svg>';
  const validPoint = point => point && Number.isFinite(point.x) && Number.isFinite(point.y) && point.x >= 0 && point.x <= 1 && point.y >= 0 && point.y <= 1;
  const esc = value => String(value ?? '').replace(/[&<>"']/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character]));
  const imageKey = value => String(value || '').split('?')[0].split('/').pop();
  const mountOf = variant => {
    const sku = String(variant.sku || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (sku === 'NANO') return 'slide';
    if (sku === 'GNANOFIXED') return 'fixed';
    const opt = String((variant.options || [])[0] || '').toLowerCase();
    if (opt.includes('slide')) return 'slide';
    if (opt.includes('fixed')) return 'fixed';
    console.warn('bm-nano: unmapped variant', variant.sku, variant.title);
    return null;
  };

  class NanoConfigurator extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-config]').textContent);
      this.variants = this.config.variants.map(variant => {
        const mount = mountOf(variant);
        return mount ? { ...variant, mount } : null;
      }).filter(Boolean);
      this.form = this.querySelector('form[data-type="add-to-cart-form"]');
      this.input = this.form?.querySelector('input[name="id"]');
      this.buy = this.form?.querySelector('button.product-form__submit[name="add"]');
      this.sticky = this.querySelector('[data-sticky-add-to-cart]');
      // Fewer than one mapped variant, or no form/id input/buy button: bail
      // before attaching anything, leaving the server-rendered page exactly
      // as-is. Without the id input there is nothing to commit a variant into.
      if (!this.variants.length || !this.form || !this.input || !this.buy) return;
      this.buy.dataset.addToCart = '';
      // The product title is not part of the config JSON contract; it is
      // already server-rendered into the intro heading, so read it from there.
      this.productTitle = this.querySelector('h1')?.textContent?.trim() || document.title;
      // The shared buy-buttons snippet renders no quantity field, so every add
      // posts 1. Dawn's product-form.js serialises the form with FormData, and
      // the shared add-on handler re-fires the same button, so one hidden field
      // is honoured by both paths.
      this.quantity = 1;
      this.qtyInput = this.ensureQuantityInput();
      const landingId = new URL(location.href).searchParams.get('variant');
      const initial = this.variants.find(variant => String(variant.id) === landingId)
        || this.variants.find(variant => variant.id === this.config.selectedId)
        || this.variants[0];
      let committed = false;
      try {
        committed = this.commit(initial, false);
      } catch (error) {
        // The first commit threw (commit() already logged it): never attach the
        // submit/click guards below, or the native, server-rendered add-to-cart
        // form would be blocked shut for the rest of the visit with no visual
        // cue at all.
        return;
      }
      // commit() also declines silently when the buy button is already busy.
      // Same rule: no guards, no body class, the SSR page stays as served.
      if (!committed) {
        console.warn('bm-nano: initial commit did not run');
        return;
      }
      this.boundClick = this.onClick.bind(this);
      this.addEventListener('click', this.boundClick);
      this.boundSubmit = event => {
        if (this.changing || !this.selected?.available || this.buy.disabled) {
          event.preventDefault(); event.stopImmediatePropagation();
        }
      };
      this.form.addEventListener('submit', this.boundSubmit, true);
      this.boundPurchaseClick = event => {
        if (event.target.closest?.('button') !== this.buy) return;
        if (this.changing || this.busy() || this.buy.disabled || !this.selected?.available) {
          event.preventDefault(); event.stopImmediatePropagation();
        }
      };
      // Runs before the existing document-level paid-accessory handler.
      window.addEventListener('click', this.boundPurchaseClick, true);
      this.querySelectorAll('dialog').forEach(dialog => {
        dialog.addEventListener('close', () => this.onDialogClose(dialog));
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
      });
      this.buttonObserver = new MutationObserver(() => this.syncPurchase());
      this.buttonObserver.observe(this.buy, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'class'], childList: true, subtree: true, characterData: true });
      this.visibilityObserver = new IntersectionObserver(entries => {
        this.nativePurchaseVisible = entries[0].intersectionRatio >= 0.9;
        this.syncStickyVisibility();
        this.scheduleChatPlacement();
      }, { threshold: [0, 0.9, 1] });
      this.visibilityObserver.observe(this.buy);
      this.boundPopstate = () => {
        const id = new URL(location.href).searchParams.get('variant');
        const variant = this.variants.find(candidate => String(candidate.id) === id);
        if (variant && !this.busy()) this.commit(variant, false);
      };
      window.addEventListener('popstate', this.boundPopstate);
      this.boundVat = () => { this.syncTaxLabel(); this.scheduleExtrasPricing(); };
      document.addEventListener('spx:vat:ready', this.boundVat);
      document.addEventListener('spx:vat:change', this.boundVat);
      document.body.classList.add('bmc-preview-page');
      this.loadContents();
      this.mobilePurchase = matchMedia('(max-width:767px)');
      this.boundMobilePurchase = () => this.placeMobilePurchase();
      this.mobilePurchase.addEventListener('change', this.boundMobilePurchase);
      this.placeExtras();
      this.setupChatPlacement();
      this.extraObserver = new MutationObserver(() => this.placeExtras());
      this.extraObserver.observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
      this.extraTimeout = setTimeout(() => this.extraObserver.disconnect(), 16000);
      // The single global this module adds. The story page's setup cards drive
      // the quantity preset through it, and gate their own visibility on it:
      // no BMNano means no way to post two units, so no Dual card is offered.
      this.api = {
        setQuantity: quantity => this.setQuantity(quantity),
        available: mount => !!this.variantForMount(mount)?.available
      };
      window.BMNano = this.api;
      this.syncUnitsGuard();
      this.unitTimers = [250, 700, 1500, 3000, 6000].map(ms => setTimeout(() => this.syncUnitsGuard(), ms));
    }

    disconnectedCallback() {
      this.mobilePurchase?.removeEventListener('change', this.boundMobilePurchase);
      this.placeMobilePurchase(true);
      this.extrasHome?.remove(); this.extrasHome = null;
      this.ownerHome?.remove(); this.ownerHome = null;
      this.buttonObserver?.disconnect();
      this.allocationObserver?.disconnect();
      this.unitTimers?.forEach(clearTimeout);
      this.visibilityObserver?.disconnect();
      this.extraObserver?.disconnect();
      clearTimeout(this.extraTimeout);
      window.removeEventListener('popstate', this.boundPopstate);
      document.removeEventListener('spx:vat:ready', this.boundVat);
      document.removeEventListener('spx:vat:change', this.boundVat);
      window.removeEventListener('click', this.boundPurchaseClick, true);
      this.removeEventListener('click', this.boundClick);
      this.cleanupChatPlacement();
      this.cleanupExtrasPricing();
      this.form?.removeEventListener('submit', this.boundSubmit, true);
      document.body.classList.remove('bmc-dialog-open', 'bmc-preview-page', 'bmc-sticky-active');
      document.body.style.overflow = this.previousOverflow || '';
      // Only retract our own handle: a second instance may already own it.
      if (window.BMNano === this.api) delete window.BMNano;
      this.initialized = false;
    }

    t(key, values = {}) {
      const text = this.config.messages?.[key] || EN_MESSAGES[key] || key;
      return text.replace(/\{([a-z_]+)\}/g, (match, name) => Object.prototype.hasOwnProperty.call(values, name) ? String(values[name]) : match);
    }
    swissMarket() { return this.config.country === 'CH' || window.Shopify?.country === 'CH'; }
    taxTerm() {
      const country = this.config.country || window.SPXVat?.country;
      if (country === 'AU' || country === 'NZ') return 'GST';
      if (this.swissMarket() && /^de(?:-|$)/i.test(this.config.locale || document.documentElement.lang)) return 'MWST';
      return this.t('vat');
    }
    busy() { return this.buy.getAttribute('aria-disabled') === 'true' || this.buy.getAttribute('aria-busy') === 'true' || this.buy.classList.contains('loading'); }
    variantForMount(mount) { return this.variants.find(variant => variant.mount === mount); }
    setText(selector, value) { const node = this.querySelector(selector); if (node && node.textContent !== String(value)) node.textContent = value; }
    compactPrice(label) {
      const code = String(this.config.currency || '').replace(/[^A-Z]/g, '');
      const value = String(label ?? '');
      return code ? value.replace(new RegExp(`\\s*${code}\\s*$`), '').trim() : value;
    }
    setPrice(selector, cents, label) {
      const node = this.querySelector(selector); if (!node) return;
      node.textContent = label;
      node.dataset.vatCents = cents;
      delete node.dataset.vatOrig;
      delete node.dataset.vatState;
    }
    syncTaxLabel() {
      const vat = window.SPXVat;
      if (this.swissMarket()) {
        this.setText('[data-tax-basis]', this.t('swiss_excluded', { tax: this.taxTerm() }));
        this.setText('[data-sticky-tax]', this.t('tax_excluding_short', { tax: this.taxTerm() }));
        this.setText('[data-extra-tax-basis]', this.t('swiss_excluded', { tax: this.taxTerm() }));
        return;
      }
      const fallback = this.t(this.config.taxesIncluded ? 'tax_included' : 'tax_checkout');
      const label = vat?.available ? this.t(vat.enabled ? 'tax_including_rate' : 'tax_excluding_checkout', { tax: this.taxTerm(), rate: vat.rate }) : fallback;
      this.setText('[data-tax-basis]', label);
      this.setText('[data-sticky-tax]', vat?.available ? this.t(vat.enabled ? 'tax_including_short' : 'tax_excluding_short', { tax: this.taxTerm() }) : this.config.taxesIncluded ? this.t('tax_included_short') : '');
      this.setText('[data-extra-tax-basis]', label);
    }

    // The shared buy-buttons snippet renders no quantity control, so the form
    // would post 1 whatever the customer picked. One hidden field serves both
    // the native add and the shared add-on handler's passthrough re-click. An
    // existing field is reused rather than shadowed: two inputs named quantity
    // would both be serialised.
    ensureQuantityInput() {
      let input = this.form.querySelector('input[name="quantity"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'quantity';
        input.setAttribute('data-bmc-qty', '');
        this.form.appendChild(input);
      }
      input.value = '1';
      return input;
    }

    // The one public way to change how many units the form posts. Never touches
    // input[name=id]: the variant is the mount, the quantity is the preset.
    setQuantity(quantity) {
      const wanted = Math.round(Number(quantity));
      let next = Number.isFinite(wanted) ? Math.min(MAX_QUANTITY, Math.max(1, wanted)) : 1;
      // The batch check lives here, not only in the controls, because this is
      // the single door to the number the form posts. A caller that asks for
      // two units when the open batch cannot cover two gets one, whatever it is
      // and whenever it asks.
      if (next > 1 && !this.unitsAllowed()) next = 1;
      this.quantity = next;
      if (this.qtyInput) this.qtyInput.value = String(next);
      this.paintPrice();
      // setPrice rewrites data-vat-cents and clears the VAT module's cached
      // original, so the module has to repaint or the screen keeps the old total.
      window.SPXVat?.refresh();
      this.syncPurchase();
      return next;
    }

    // Paints every price surface from the committed variant and the current
    // quantity, and returns the configuration summary it wrote.
    paintPrice() {
      const variant = this.selected;
      if (!variant) return '';
      const quantity = this.quantity;
      const total = variant.price * quantity;
      const unitLabel = this.compactPrice(variant.priceLabel);
      // The multi-unit label comes from Shopify's own money filter through the
      // config JSON, never from a JS formatter: the shop's money format is not
      // the browser locale's, and a mismatched separator is a wrong price.
      const totalLabel = quantity > 1 ? this.compactPrice(variant.dualPriceLabel) : unitLabel;
      this.setPrice('[data-current-price]', total, totalLabel);
      this.setPrice('[data-sticky-price]', total, totalLabel);
      const note = this.querySelector('[data-qty-note]');
      if (note) {
        if (quantity > 1) {
          // Split the message around its price placeholder so the amount sits
          // in a node of its own: the VAT module rewrites the number inside a
          // tagged element, and it refuses to when a second number (the unit
          // count) shares the same string. Splitting keeps the note tracking
          // the toggle instead of freezing at the ex-VAT figure.
          const marker = '\u0001';
          const parts = this.t('qty_note', { qty: quantity, price: marker }).split(marker);
          this.setText('[data-qty-note-lead]', parts[0] || '');
          this.setPrice('[data-qty-note-price]', variant.price, unitLabel);
          this.setText('[data-qty-note-tail]', parts.slice(1).join(marker));
        }
        note.hidden = quantity < 2;
      }
      const base = `${this.productTitle} · ${this.t(MOUNTS[variant.mount].title)}`;
      const summary = quantity > 1 ? `${base} ${this.t('dual_suffix').trim()}` : base;
      this.setText('[data-selected-summary]', summary);
      this.setText('[data-sticky-summary]', summary);
      // The box explorer lists what one unit ships with, so its heading stays
      // singular however many units the order carries.
      this.setText('[data-contents-summary]', base);
      const compare = this.querySelector('[data-compare-price]');
      if (compare) {
        // A one-unit compare-at price beside a two-unit total would read as a
        // saving that does not exist.
        compare.hidden = quantity > 1 || !(variant.comparePrice > variant.price);
        this.setPrice('[data-compare-price]', variant.comparePrice, compare.hidden ? '' : this.compactPrice(variant.compareLabel));
      }
      this.renderUnits();
      return summary;
    }

    // The unit-count control, painted from the committed variant and the current
    // quantity. Each button carries its own data-vat-cents so the VAT toggle
    // rewrites both prices the same way it rewrites the price row.
    renderUnits() {
      const variant = this.selected;
      if (!variant || !this.querySelector('[data-unit-options]')) return;
      this.setPrice('[data-units-price="1"]', variant.price, this.compactPrice(variant.priceLabel));
      this.setPrice('[data-units-price="2"]', variant.price * 2, this.compactPrice(variant.dualPriceLabel));
      this.querySelectorAll('[data-units]').forEach(button => {
        button.setAttribute('aria-pressed', String(Number(button.dataset.units) === this.quantity));
      });
      const note = this.querySelector('[data-units-note]');
      if (note) note.hidden = this.quantity < 2;
    }

    // The batch behind the open pre-order. The panel shows HALF the remaining
    // allocation rounded down, so a displayed integer of 1 already means at
    // least two real units; the no-number "final units" state carries no count
    // and may be a single unit, so an absent .bma-n reads as "not enough".
    unitsAllowed() {
      if (!this.selected?.available) return false;
      const panel = document.querySelector('[data-bm-allocation]');
      if (!panel || panel.hasAttribute('hidden')) return false;
      const node = panel.querySelector('.bma-n');
      if (!node) return false;
      const digits = String(node.textContent || '').replace(/[^0-9]/g, '');
      if (!digits) return false;
      const left = parseInt(digits, 10);
      return Number.isFinite(left) && left >= 1;
    }

    // The panel dispatches no event of its own: it swaps its card markup
    // wholesale, rewrites the number in place and toggles its own hidden flag.
    watchAllocation() {
      const panel = document.querySelector('[data-bm-allocation]');
      if (!panel || panel === this.watchedAllocation) return;
      this.watchedAllocation = panel;
      this.allocationObserver?.disconnect();
      this.allocationObserver = new MutationObserver(() => this.syncUnitsGuard());
      this.allocationObserver.observe(panel, {
        childList: true, subtree: true, characterData: true,
        attributes: true, attributeFilter: ['hidden']
      });
    }

    syncUnitsGuard() {
      const fieldset = this.querySelector('[data-unit-options]');
      if (!fieldset) return;
      this.watchAllocation();
      const allowed = this.unitsAllowed();
      fieldset.hidden = !allowed;
      // Withdrawing the control must withdraw the quantity with it, or the form
      // would still post two units with nothing on screen saying so.
      if (!allowed && this.quantity !== 1) this.setQuantity(1);
    }

    // The accessory-pack popover reads these two attributes off the row at click
    // time, and the shared section that writes them is translated in only a few
    // locales. Rewrite them for the Nano pack row alone, from this module's own
    // catalog; every other row keeps exactly what the shared section wrote.
    localiseExtras() {
      const row = this.extraPricingRoot?.querySelector(`.gm2ax__row[data-handle="${PACK_HANDLE}"]`);
      if (!row) return;
      [['pack_summary', 'axSummary'], ['pack_bullets', 'axBullets']].forEach(([key, attribute]) => {
        const value = this.t(key);
        if (!value || row.dataset[attribute] === value) return;
        row.dataset[attribute] = value;
      });
    }

    // Returns true when the whole body ran, false when it declined up front.
    // connectedCallback attaches its guards only on true.
    commit(variant, updateUrl = true, announcement = '') {
      if (!variant || this.busy()) return false;
      try {
        this.changing = true;
        const commitNumber = this.commitNumber = (this.commitNumber || 0) + 1;
        this.selected = variant;
        this.dataset.selectedVariantId = variant.id;
        this.dataset.selectedMount = variant.mount;
        this.input.value = variant.id;
        this.input.disabled = false;
        this.buy.disabled = !variant.available;
        // Fixed-Mount was never on sale: "coming soon", never "sold out".
        // buy-buttons.liquid is a shared snippet: treat its inner span as optional.
        const buyLabel = variant.available ? this.config.addLabel : this.t('coming_soon_button');
        const buyLabelNode = this.buy.querySelector('span');
        if (buyLabelNode) buyLabelNode.textContent = buyLabel; else this.buy.textContent = buyLabel;
        // A mount switch always drops back to a single unit: a quantity chosen
        // for the previous mount must never survive into the new one. The
        // caller re-applies a preset afterwards, through setQuantity().
        this.quantity = 1;
        if (this.qtyInput) this.qtyInput.value = '1';
        const summary = this.paintPrice();
        this.renderOptions();
        this.selectImageForVariant(variant);
        this.syncTaxLabel();
        window.SPXVat?.refresh();
        if (updateUrl || window.Shopify?.theme?.role === 'unpublished') {
          const url = new URL(location.href);
          url.searchParams.set('variant', variant.id);
          if (window.Shopify?.theme?.role === 'unpublished') url.searchParams.set('preview_theme_id', window.Shopify.theme.id);
          history.replaceState({ ...history.state, variantId: variant.id }, '', url);
        }
        // Existing preorder, delivery and add-on modules consume this committed form ID.
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
        this.syncPurchase();
        // Let the existing stock modules finish their deferred gates before the sticky action is enabled.
        requestAnimationFrame(() => requestAnimationFrame(() => {
          if (this.commitNumber !== commitNumber) return;
          this.changing = false; this.syncPurchase();
          const visiblePrice = this.querySelector('[data-current-price]').textContent.trim();
          // A preset may have raised the quantity since this commit ran, so the
          // spoken line reads the summary that is actually on screen next to
          // that price rather than the one-unit string captured earlier.
          const spoken = this.querySelector('[data-selected-summary]')?.textContent.trim() || summary;
          this.setText('[data-selection-status]', announcement || this.t(variant.available ? 'selection_available' : 'selection_sold_out', { configuration: spoken, price: visiblePrice }));
          this.syncUnitsGuard();
        }));
        return true;
      } catch (error) {
        this.changing = false;
        // The repaint is best-effort: the original failure must still be
        // logged and rethrown even if the repaint itself throws.
        try { this.syncPurchase(); } catch (syncError) { console.error('bm-nano sync after failed commit', syncError); }
        console.error('bm-nano commit failed', error);
        throw error;
      }
    }

    renderOptions() {
      const container = this.querySelector('[data-mount-options]');
      if (container) {
        container.innerHTML = MOUNT_ORDER
          .map(mount => ({ mount, variant: this.variantForMount(mount) }))
          .filter(entry => entry.variant)
          .map(({ mount, variant }) => {
            const meta = MOUNTS[mount];
            const pressed = variant.id === this.selected.id;
            const badgeState = variant.available ? 'preorder' : 'coming';
            const badgeText = this.t(variant.available ? 'badge_preorder' : 'badge_coming');
            const image = this.config.mountCards?.[mount]?.image || '';
            const title = this.t(meta.title);
            // The card button and the "see what's included" link are siblings
            // inside one wrapper: a button may not contain another button.
            return `<div class="bmc-model-wrap" data-mount-wrap="${mount}"><button type="button" class="bmc-model" data-mount="${mount}" data-variant-id="${variant.id}" aria-pressed="${pressed}" aria-label="${esc(this.t('choose_named_mount', { mount: title }))}"><img class="bmc-model__thumb" src="${esc(image)}" alt="" width="96" height="96" loading="lazy"><span class="bmc-model__title" data-mount-title>${esc(title)}</span><span class="bmc-model__fit" data-mount-fit>${esc(this.t(meta.fit))}</span><span class="bmc-badge" data-mount-badge data-state="${badgeState}">${esc(badgeText)}</span><span class="bmc-model__price" data-mount-price data-vat-cents="${variant.price}">${esc(this.compactPrice(variant.priceLabel))}</span></button><button type="button" class="bmc-model__box" data-open-box="${mount}" aria-label="${esc(this.t('whats_included'))}">${BOX_ICON}<span>${esc(this.t('whats_in_box'))}</span></button></div>`;
          }).join('');
      }
      MOUNT_ORDER.forEach(mount => {
        const variant = this.variantForMount(mount);
        const cell = this.querySelector(`[data-compare-avail="${mount}"]`);
        if (cell && variant) cell.textContent = this.t(variant.available ? 'badge_preorder' : 'badge_coming');
      });
    }

    // Match the Liquid ownership contract using IDs, never titles or filenames.
    variantGalleryImages(variant = this.selected) {
      const ownership = this.config.galleryOwnership?.version === 1 ? this.config.galleryOwnership : {};
      const mediaOwners = ownership.media || {};
      const images = (this.config.images || []).filter(Boolean);
      const selectedId = String(variant?.id ?? '');
      const nativeMediaId = candidate => candidate?.mediaId ?? images.find(image =>
        candidate?.imageId != null && String(image.imageId) === String(candidate.imageId))?.id;
      const ownersFor = image => {
        if (Object.prototype.hasOwnProperty.call(mediaOwners, String(image.id)) && Array.isArray(mediaOwners[String(image.id)])) {
          return mediaOwners[String(image.id)].map(String);
        }
        const native = this.config.variants.filter(candidate => String(nativeMediaId(candidate) ?? '') === String(image.id));
        return native.length ? native.map(candidate => String(candidate.id)) : null;
      };
      const allowed = images.filter(image => {
        const owners = ownersFor(image);
        return owners === null || owners.includes(selectedId);
      });
      const mappedHero = ownership.featured?.[selectedId];
      const nativeHero = nativeMediaId(variant);
      const hero = allowed.find(image => mappedHero != null && String(image.id) === String(mappedHero))
        || allowed.find(image => nativeHero != null && String(image.id) === String(nativeHero))
        || allowed.find(image => ownersFor(image)?.includes(selectedId))
        || allowed[0];
      return hero ? [hero, ...allowed.filter(image => image !== hero)] : [];
    }

    renderGallery() {
      this.gallery = this.variantGalleryImages();
      const strip = this.querySelector('[data-gallery]');
      if (strip) {
        strip.innerHTML = this.gallery.map((image, index) => `<button type="button" data-gallery-index="${index}" aria-pressed="false" aria-label="${esc(this.t('numbered_photo', { index: index + 1 }))}"><img src="${esc(image.src)}" alt="" width="50" height="50" loading="lazy"></button>`).join('');
      }
    }

    selectGallery(index) {
      const image = this.gallery?.[index];
      if (!image) return;
      this.galleryIndex = index;
      const target = this.querySelector('[data-product-image]');
      const alt = image.alt || this.productTitle;
      if (target) {
        if (target.getAttribute('src') !== image.src) target.src = image.src;
        target.alt = alt;
      }
      const zoom = this.querySelector('[data-zoom-image]');
      if (zoom) {
        if (zoom.getAttribute('src') !== image.src) zoom.src = image.src;
        zoom.alt = alt;
      }
      this.querySelectorAll('[data-gallery-index]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.galleryIndex) === index)));
    }

    selectImageForVariant(variant) {
      this.renderGallery();
      if (this.gallery.length) this.selectGallery(0);
      else {
        // A no-media selection must not retain another mount's photograph.
        this.galleryIndex = -1;
        this.querySelectorAll('[data-product-image], [data-zoom-image]').forEach(image => {
          image.removeAttribute('src');
          image.alt = '';
        });
      }
    }

    async loadContents() {
      try {
        const response = await fetch(this.dataset.contentsUrl, { credentials: 'omit' });
        if (!response.ok) throw new Error('Contents unavailable');
        const contents = await response.json();
        if (!contents.images || !Array.isArray(contents.items) || contents.items.length < 8
          || !contents.items.every(item => item.id && item.label_key && Array.isArray(item.mounts))) {
          throw new Error('Incomplete item data');
        }
        this.contents = contents;
        const errorNode = this.querySelector('[data-contents-error]');
        if (errorNode) errorNode.hidden = true;
        if (this.pendingBoxMount) {
          const mount = this.pendingBoxMount;
          this.pendingBoxMount = null;
          this.showBox(mount);
        }
      } catch (error) {
        this.contentsFailed = true;
        const node = this.querySelector('[data-contents-error]');
        if (node) { node.textContent = this.t('items_error'); node.hidden = false; }
      }
    }

    includedItemsForMount(mount) {
      return this.contents ? this.contents.items.filter(item => item.mounts.includes(mount)) : [];
    }
    itemLabel(item) { return this.t(item.label_key); }
    itemPurpose(item) { return this.t(item.purpose_key); }
    defaultItemFor(mount) {
      const items = this.includedItemsForMount(mount);
      const mountItemId = mount === 'slide' ? 'slide-mount' : 'knob-mount';
      return items.some(item => item.id === mountItemId) ? mountItemId : items[0]?.id;
    }

    showBox(mount, trigger) {
      if (!this.contents) {
        this.pendingBoxMount = mount;
        const list = this.querySelector('[data-item-list]');
        if (list) list.innerHTML = '';
        const errorNode = this.querySelector('[data-contents-error]');
        if (errorNode) {
          errorNode.hidden = false;
          errorNode.textContent = this.contentsFailed ? this.t('items_error') : this.t('items_loading');
        }
        this.openDialog('included', trigger);
        return;
      }
      this.explorerMount = mount;
      this.activeItemId = this.defaultItemFor(mount);
      const errorNode = this.querySelector('[data-contents-error]');
      if (errorNode) errorNode.hidden = true;
      this.renderBoxTabs();
      this.renderBoxList();
      this.paintExplorer();
      this.openDialog('included', trigger);
    }

    renderBoxTabs() {
      this.querySelectorAll('[data-box-mount]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.boxMount === this.explorerMount));
      });
    }

    renderBoxList() {
      const list = this.querySelector('[data-item-list]');
      if (!list) return;
      const items = this.includedItemsForMount(this.explorerMount);
      list.innerHTML = items.map(item => `<button type="button" data-item-id="${esc(item.id)}" aria-pressed="${item.id === this.activeItemId}"><span>${esc(this.itemLabel(item))}</span></button>`).join('');
    }

    paintExplorer() {
      const items = this.includedItemsForMount(this.explorerMount);
      const item = items.find(candidate => candidate.id === this.activeItemId) || items[0];
      if (!item) return;
      const imageKeyName = item.image || 'hero';
      const src = this.config.boxImages?.[imageKeyName] || this.config.boxImages?.hero || '';
      const image = this.querySelector('[data-item-image]');
      if (image) {
        if (image.getAttribute('src') !== src) image.src = src;
        image.alt = this.itemLabel(item);
      }
      this.setText('[data-item-label]', this.itemLabel(item));
      this.setText('[data-item-purpose]', this.itemPurpose(item));
      this.setText('[data-included-with]', this.t('included_with', { mount: this.t(MOUNTS[this.explorerMount].title) }));
      const index = items.findIndex(candidate => candidate.id === item.id);
      const count = items.length;
      const counter = this.querySelector('[data-item-count]');
      if (counter) {
        // Digits only in the visible stepper; the spoken label is the message.
        this.setText('[data-item-count]', `${index + 1} / ${count}`);
        counter.setAttribute('aria-label', this.t('included_count', { count }));
      }
      const layer = this.querySelector('[data-item-hotspots]');
      if (layer) {
        if (imageKeyName === 'hero') {
          const pins = items.filter(candidate => (candidate.image || 'hero') === 'hero' && validPoint(candidate.point));
          layer.innerHTML = pins.map(pin => `<button type="button" class="bmc-pin" data-hotspot data-item-id="${esc(pin.id)}" aria-pressed="${String(pin.id === item.id)}" aria-label="${esc(this.itemLabel(pin))}" style="left:${(pin.point.x * 100).toFixed(2)}%;top:${(pin.point.y * 100).toFixed(2)}%"></button>`).join('');
        } else {
          layer.innerHTML = '';
        }
      }
      this.querySelectorAll('[data-item-id]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.itemId === item.id)));
    }

    selectExplorerItem(id) {
      const items = this.includedItemsForMount(this.explorerMount);
      if (!items.some(item => item.id === id)) return;
      this.activeItemId = id;
      this.paintExplorer();
    }

    stepExplorerItem(direction) {
      const items = this.includedItemsForMount(this.explorerMount);
      const index = items.findIndex(item => item.id === this.activeItemId);
      if (index < 0 || !items.length) return;
      const next = items[(index + direction + items.length) % items.length];
      this.selectExplorerItem(next.id);
    }

    syncPurchase() {
      if (!this.buy || !this.sticky) return;
      const busy = this.busy();
      const unavailable = this.buy.disabled || this.buy.getAttribute('aria-disabled') === 'true';
      this.sticky.disabled = this.changing || busy || unavailable;
      const buyLabelNode = this.buy.querySelector('span');
      this.sticky.textContent = busy ? this.t('adding') : (buyLabelNode ? buyLabelNode.textContent : this.buy.textContent).trim();
      this.sticky.setAttribute('aria-busy', String(busy));
      // The sticky button is deliberately NOT in this list: its disabled state
      // is the line above (changing || busy || unavailable), which this loop
      // would otherwise overwrite with the weaker `busy` alone.
      this.querySelectorAll('[data-mount],[data-open-box],[data-units]').forEach(button => { button.disabled = busy; });
    }

    openDialog(name, trigger) {
      const dialog = this.querySelector(`[data-dialog="${name}"]`); if (!dialog) return;
      const previous = this.querySelector('dialog[open]');
      if (!previous) {
        this.dialogTrigger = trigger;
        this.previousOverflow = document.body.style.overflow;
      }
      if (previous && previous !== dialog) { previous.dataset.skipRestore = 'true'; previous.close(); }
      document.body.style.overflow = 'hidden';
      document.body.classList.add('bmc-dialog-open');
      dialog.showModal();
      if (name === 'included') {
        const scrollHost = dialog.querySelector('.bmc-contents-layout');
        if (scrollHost) scrollHost.scrollTop = 0;
      }
    }

    closeDialogs() { this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close()); }

    onDialogClose(dialog) {
      this.scheduleChatPlacement();
      if (!this.querySelector('dialog[open]')) {
        document.body.classList.remove('bmc-dialog-open');
        document.body.style.overflow = this.previousOverflow || '';
      }
      if (dialog.dataset.skipRestore === 'true') { delete dialog.dataset.skipRestore; return; }
      if (this.dialogTrigger?.isConnected) this.dialogTrigger.focus({ preventScroll: true });
      else this.querySelector(`[data-open-dialog="${dialog.dataset.dialog}"]`)?.focus({ preventScroll: true });
    }

    placeExtras() {
      const extras = document.querySelector('.gm2ax');
      const slot = this.querySelector('[data-extra-slot]');
      if (extras && slot && !slot.contains(extras)) slot.appendChild(extras);
      if (extras && slot?.contains(extras)) this.setupExtrasPricing(extras);
      this.placeMobilePurchase();
    }

    placeMobilePurchase(restore = false) {
      const slot = this.querySelector('[data-extra-slot]');
      const nativeForm = this.form?.closest('product-form');
      const wrapper = nativeForm?.parentElement;
      const owner = this.querySelector('.bmc-purchase .bmo-purchase');
      const active = document.activeElement;
      const preserveFocus = active && (slot?.contains(active) || owner?.contains(active));
      if (!restore && this.mobilePurchase?.matches && slot && wrapper?.classList.contains('product__buy-buttons')) {
        if (!this.extrasHome) {
          this.extrasHome = document.createComment('Nano native accessories position');
          slot.before(this.extrasHome);
        }
        if (nativeForm.nextElementSibling !== slot) nativeForm.after(slot);
        if (owner) {
          if (!this.ownerHome) {
            this.ownerHome = document.createComment('Nano owner guidance position');
            owner.before(this.ownerHome);
          }
          if (slot.nextElementSibling !== owner) slot.after(owner);
        }
      } else {
        if (this.extrasHome?.parentNode && this.extrasHome.nextSibling !== slot) this.extrasHome.after(slot);
        if (owner && this.ownerHome?.parentNode && this.ownerHome.nextSibling !== owner) this.ownerHome.after(owner);
      }
      // Moving an existing control can blur it; keep in-progress keyboard input intact.
      if (preserveFocus && active.isConnected && document.activeElement !== active) active.focus({ preventScroll: true });
    }

    setupExtrasPricing(root) {
      if (this.extraPricingRoot === root) return;
      this.cleanupExtrasPricing();
      this.extraPricingRoot = root;
      this.boundExtraPriceChange = event => {
        if (event.target.matches?.('.gm2ax__cb')) this.scheduleExtrasPricing();
      };
      this.localiseExtras();
      root.addEventListener('change', this.boundExtraPriceChange);
      // Native code rewrites summary text and updates inclusion after selection changes.
      // Our money writes use characterData, which this observer deliberately ignores.
      this.extraPricingObserver = new MutationObserver(() => this.scheduleExtrasPricing());
      this.extraPricingObserver.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'data-state', 'hidden'] });
      this.scheduleExtrasPricing();
    }

    scheduleExtrasPricing() {
      if (!this.extraPricingRoot || this.extraPricingFrame) return;
      this.extraPricingFrame = requestAnimationFrame(() => {
        this.extraPricingFrame = 0;
        this.syncExtrasPricing();
      });
    }

    writeExtraText(node, value) {
      if (!node || node.textContent === value) return;
      if (node.childNodes.length === 1 && node.firstChild.nodeType === Node.TEXT_NODE) node.firstChild.nodeValue = value;
      else node.textContent = value;
    }

    extraMoney(cents) {
      const currency = this.config.currency || window.Shopify?.currency?.active || 'EUR';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100);
      } catch (_) { return `${currency} ${(cents / 100).toFixed(2)}`; }
    }

    extraRowNet(row, full, discounts) {
      if (!discounts) return full;
      const type = row.dataset.discType || 'pct';
      const value = parseFloat(row.dataset.discValue || '20') || 0;
      const off = type === 'fixed' ? Math.round(value) : Math.round(full * value / 100);
      return full - Math.max(0, Math.min(full, off));
    }

    syncExtrasPricing() {
      const root = this.extraPricingRoot;
      if (!root?.isConnected) return;
      // Runs on the observer tick too, so the popover attributes are already
      // ours by the time any (i) button can be clicked.
      this.localiseExtras();
      const discounts = root.dataset.accDisc !== 'false';
      const offer = this.querySelector('[data-accessory-offer]');
      if (offer) offer.hidden = !discounts;
      const displayed = cents => !this.swissMarket() && window.SPXVat?.applyRate ? window.SPXVat.applyRate(cents) : Math.round(cents);
      const saveLabel = root.dataset.tSave || this.t('save');
      let selectedCount = 0, selectedFull = 0, selectedNet = 0;
      const benefits = {
        'speediance-gym-nano-advanced-accessory-pack': this.t('pack_benefit')
      };
      root.querySelectorAll('.gm2ax__row[data-variant]').forEach(row => {
        const full = parseInt(row.dataset.price, 10) || 0;
        const net = this.extraRowNet(row, full, discounts);
        const fullShown = displayed(full), netShown = displayed(net);
        this.writeExtraText(row.querySelector('.gm2ax__was'), this.extraMoney(fullShown));
        this.writeExtraText(row.querySelector('.gm2ax__now'), this.extraMoney(netShown));
        this.writeExtraText(row.querySelector('.gm2ax__flat'), this.extraMoney(fullShown));
        this.writeExtraText(row.querySelector('.gm2ax__newbadge--velo'), `${saveLabel} ${this.extraMoney(fullShown - netShown)}`);
        const preorderNote = row.querySelector('.gm2ax__prenote');
        if (preorderNote && row.dataset.preorder && root.dataset.tAccPre) {
          const match = row.dataset.preorder.match(/^(\d{4})-(\d{2})-(\d{2})/);
          if (match) {
            const date = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3])));
            const dateLabel = new Intl.DateTimeFormat(this.config.locale || document.documentElement.lang || 'en', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' }).format(date);
            this.writeExtraText(preorderNote, root.dataset.tAccPre.replace('%date%', dateLabel));
          }
        }
        const checkbox = row.querySelector('.gm2ax__cb');
        if (checkbox?.checked && !checkbox.disabled) {
          selectedCount++; selectedFull += fullShown; selectedNet += netShown;
        }
        const label = benefits[row.dataset.handle || (row.classList.contains('gm2ax__row--velo') ? 'velonix' : '')];
        const info = row.querySelector('.gm2ax__info');
        if (label && info && !info.querySelector('.bmc-extra-benefit')) {
          const benefit = document.createElement('span'); benefit.className = 'bmc-extra-benefit'; benefit.textContent = label;
          const name = info.querySelector('.gm2ax__name');
          if (name) name.insertAdjacentElement('afterend', benefit); else info.appendChild(benefit);
        }
      });
      if (selectedCount) {
        this.writeExtraText(root.querySelector('[data-gm2ax-was]'), discounts ? `+${this.extraMoney(selectedFull)}` : '');
        this.writeExtraText(root.querySelector('[data-gm2ax-sum]'), `+${this.extraMoney(selectedNet)}`);
        this.writeExtraText(root.querySelector('[data-gm2ax-save]'), discounts ? `${saveLabel} ${this.extraMoney(selectedFull - selectedNet)}` : '');
      }
      const vat = window.SPXVat;
      const basis = this.swissMarket() ? this.t('tax_excluding_short', { tax: this.taxTerm() }) : vat?.available ? this.t(vat.enabled ? 'tax_including_short' : 'tax_excluding_short', { tax: this.taxTerm() }) : this.t(this.config.taxesIncluded ? 'tax_included_short' : 'tax_checkout_short');
      const summary = selectedCount ? this.t('extras_summary', { count: selectedCount, price: this.extraMoney(selectedNet), basis }) : '';
      this.querySelectorAll('[data-extra-selection-summary],[data-sticky-extra-summary]').forEach(node => {
        node.hidden = !selectedCount;
        const compact = selectedCount ? this.t('extras_compact', { count: selectedCount, price: this.extraMoney(selectedNet) }) : '';
        this.writeExtraText(node, node.hasAttribute('data-sticky-extra-summary') ? compact : summary);
      });
      root.dataset.bmcVatState = vat?.enabled ? 'incl' : 'excl';
      this.syncTaxLabel();
    }

    cleanupExtrasPricing() {
      if (this.extraPricingFrame) cancelAnimationFrame(this.extraPricingFrame);
      this.extraPricingFrame = 0;
      this.extraPricingObserver?.disconnect();
      this.extraPricingRoot?.removeEventListener('change', this.boundExtraPriceChange);
      this.extraPricingRoot = null;
    }

    syncStickyVisibility() {
      const visible = window.matchMedia('(max-width: 767px)').matches || !this.nativePurchaseVisible;
      const bar = this.querySelector('[data-sticky-bar]');
      if (bar.dataset.visible !== String(visible)) bar.dataset.visible = String(visible);
      document.body.classList.toggle('bmc-sticky-active', visible);
    }

    setupChatPlacement() {
      this.chatSurfaces = new Set();
      this.boundChatPlacement = () => this.scheduleChatPlacement();
      this.chatResizeObserver = new ResizeObserver(this.boundChatPlacement);
      this.chatResizeObserver.observe(this); this.chatResizeObserver.observe(this.buy); this.chatResizeObserver.observe(this.form);
      const nativeClasses = value => String(value || '').split(/\s+/).filter(name => name && !['bmc-chat-clearance', 'bmc-chat-alternate-side', 'bmc-chat-teaser-paused'].includes(name)).sort().join(' ');
      this.chatStateObserver = new MutationObserver(records => {
        if (records.some(record => record.attributeName !== 'class' || nativeClasses(record.oldValue) !== nativeClasses(record.target.className))) this.scheduleChatPlacement();
      });
      this.chatStateObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['data-bm-chat'] });
      this.chatDiscoveryObserver = new MutationObserver(() => this.discoverChatSurfaces());
      // These native fixed surfaces are direct body children, including the late teaser.
      this.chatDiscoveryObserver.observe(document.body, { childList: true });
      this.boundChatTransition = event => {
        if (event.propertyName === 'opacity' && Array.from(this.chatSurfaces || []).some(surface => surface.contains(event.target))) this.scheduleChatPlacement();
      };
      document.body.addEventListener('transitionend', this.boundChatTransition);
      this.discoverChatSurfaces();
      window.addEventListener('scroll', this.boundChatPlacement, { passive: true });
      window.addEventListener('resize', this.boundChatPlacement, { passive: true });
      window.visualViewport?.addEventListener('resize', this.boundChatPlacement, { passive: true });
    }

    discoverChatSurfaces() {
      if (!this.chatSurfaces) return;
      for (const surface of this.chatSurfaces) {
        if (!surface.isConnected) { this.chatResizeObserver.unobserve(surface); this.chatSurfaces.delete(surface); }
      }
      document.querySelectorAll('#custom-chat-widget,#minimized-widget-icon,.bm-ux-teaser').forEach(surface => {
        if (this.chatSurfaces.has(surface)) return;
        this.chatSurfaces.add(surface);
        this.chatResizeObserver.observe(surface);
        surface.querySelectorAll('*').forEach(child => this.chatResizeObserver.observe(child));
        this.chatStateObserver.observe(surface, { attributes: true, attributeFilter: ['class'], attributeOldValue: true, subtree: true });
      });
      this.scheduleChatPlacement();
    }

    scheduleChatPlacement() {
      if (!this.chatSurfaces || this.chatPlacementFrame) return;
      this.chatPlacementFrame = requestAnimationFrame(() => {
        this.chatPlacementFrame = 0;
        this.placeChatClearOfPurchase();
      });
    }

    placeChatClearOfPurchase() {
      const surfaces = Array.from(this.chatSurfaces || []).filter(surface => surface.isConnected);
      const reset = surface => {
        surface.classList.remove('bmc-chat-clearance', 'bmc-chat-alternate-side', 'bmc-chat-teaser-paused');
        ['--bmc-chat-clearance-bottom', '--bmc-chat-left', '--bmc-chat-max-width'].forEach(name => surface.style.removeProperty(name));
      };
      // Read the native layout, including its existing sticky-bar offset.
      surfaces.forEach(reset);
      this.syncStickyVisibility();
      // An explicitly opened conversation stays at its native right anchor.
      // Purchase avoidance applies only to the passive launcher and teaser.
      const chatState = document.documentElement.getAttribute('data-bm-chat');
      if (chatState === 'open' || chatState === 'booking') return;
      // Mobile reserves a permanent slot for the real launcher in the purchase
      // dock. Content geometry must never move it while the customer scrolls.
      if (window.matchMedia('(max-width: 767px)').matches) return;
      const height = window.innerHeight, width = window.innerWidth, gap = 12;
      const rectFor = node => {
        if (!node) return null;
        const rect = node.getBoundingClientRect();
        if (!rect.width || !rect.height) return null;
        // Hidden native menus and chat transitions retain measurable geometry.
        // Only painted surfaces and controls may reserve placement space.
        for (let element = node; element; element = element.parentElement) {
          const style = getComputedStyle(element);
          if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return null;
        }
        return rect;
      };
      const inViewport = rect => rect && rect.bottom > 0 && rect.top < height && rect.right > 0 && rect.left < width;
      const targetRect = node => {
        const rect = rectFor(node); if (!inViewport(rect)) return null;
        const w = Math.max(44, rect.width), h = Math.max(44, rect.height);
        const left = rect.left + (rect.width - w) / 2, top = rect.top + (rect.height - h) / 2;
        return { left, top, right: left + w, bottom: top + h };
      };
      const primary = [this.buy, this.sticky].map(targetRect).filter(Boolean);
      const extra = Array.from(this.extraPricingRoot?.querySelectorAll('.gm2ax__cb:not(:disabled),.gm2ax__infobtn') || []).map(targetRect).filter(Boolean);
      if ((!primary.length && !extra.length) || this.querySelector('dialog[open]')) return;
      const controls = Array.from(new Set([
        ...this.querySelectorAll('button,a[href],summary,input:not([type="hidden"]),select,textarea'),
        ...document.querySelectorAll('header button,header a[href]')
      ])).filter(node => !node.disabled).map(targetRect).filter(Boolean);
      const blockers = [...primary, ...controls];
      const measure = () => surfaces.flatMap(surface => {
        const own = rectFor(surface); if (!own) return [];
        const rects = [own, ...Array.from(surface.querySelectorAll('button,a[href],input,select,textarea,[role="button"],[tabindex],.bm-ux-x,.bm-ux-teaser-x')).map(rectFor).filter(Boolean)];
        const rect = { left: Math.min(...rects.map(r => r.left)), right: Math.max(...rects.map(r => r.right)), top: Math.min(...rects.map(r => r.top)), bottom: Math.max(...rects.map(r => r.bottom)) };
        return [{ surface, rect, bottom: parseFloat(getComputedStyle(surface).bottom) || 0 }];
      });
      const intersects = (entry, button, lift = 0, padding = 0) => entry.rect.left < button.right + padding && entry.rect.right > button.left - padding && entry.rect.top - lift < button.bottom + padding && entry.rect.bottom - lift > button.top - padding;
      let entries = measure(); if (!entries.length) return;
      // Retain the native placement unless a purchase or accessory target is covered.
      if (![...primary, ...extra].some(button => entries.some(entry => intersects(entry, button)))) return;
      const findLift = current => {
        if (current.some(({rect}) => rect.left < 8 || rect.right > width - 8)) return null;
        const min = Math.max(...current.map(({rect}) => rect.bottom - (height - 8)));
        const max = Math.min(...current.map(({rect}) => rect.top - 8));
        if (min > max) return null;
        const candidates = [0, min, max];
        current.forEach(entry => blockers.forEach(button => {
          candidates.push(entry.rect.bottom - button.top + gap, entry.rect.top - button.bottom - gap);
        }));
        const positions = Array.from(new Set(candidates.map(value => Math.max(min, Math.min(max, value))))).sort((a,b) => Math.abs(a) - Math.abs(b));
        return positions.find(lift => blockers.every(button => current.every(entry => !intersects(entry, button, lift, gap)))) ?? null;
      };
      let lift = findLift(entries);
      if (lift == null && !rectFor(document.getElementById('custom-chat-widget')) && entries.some(({surface}) => surface.matches('.bm-ux-teaser'))) {
        // On a short screen, visible controls can leave no space for both
        // unsolicited surfaces. Keep chat accessible through its launcher.
        surfaces.forEach(surface => {
          reset(surface);
          if (surface.matches('.bm-ux-teaser')) surface.classList.add('bmc-chat-teaser-paused');
        });
        entries = measure();
        lift = findLift(entries);
      }
      // Keep the familiar right edge even when the page has no clear vertical
      // slot. A paused unsolicited teaser must remain paused in that case.
      if (lift == null) return;
      if (Math.abs(lift) < 0.01) return;
      entries.forEach(({surface, bottom}) => {
        surface.style.setProperty('--bmc-chat-clearance-bottom', `${bottom + lift}px`);
        surface.classList.add('bmc-chat-clearance');
      });
    }

    cleanupChatPlacement() {
      if (this.chatPlacementFrame) cancelAnimationFrame(this.chatPlacementFrame);
      this.chatPlacementFrame = 0;
      window.removeEventListener('scroll', this.boundChatPlacement);
      window.removeEventListener('resize', this.boundChatPlacement);
      window.visualViewport?.removeEventListener('resize', this.boundChatPlacement);
      document.body.removeEventListener('transitionend', this.boundChatTransition);
      this.chatResizeObserver?.disconnect(); this.chatDiscoveryObserver?.disconnect(); this.chatStateObserver?.disconnect();
      this.chatSurfaces?.forEach(surface => {
        surface.classList.remove('bmc-chat-clearance', 'bmc-chat-alternate-side', 'bmc-chat-teaser-paused');
        ['--bmc-chat-clearance-bottom', '--bmc-chat-left', '--bmc-chat-max-width'].forEach(name => surface.style.removeProperty(name));
      });
      this.chatSurfaces = null;
    }

    onClick(event) {
      const button = event.target.closest('button'); if (!button || !this.contains(button)) return;
      if (button.hasAttribute('data-mount')) {
        const variant = this.variants.find(candidate => candidate.id === Number(button.dataset.variantId));
        if (variant) this.commit(variant);
      } else if (button.hasAttribute('data-open-box')) {
        event.stopPropagation();
        this.showBox(button.dataset.openBox || this.selected.mount, button);
      } else if (button.hasAttribute('data-open-dialog')) {
        // The photo zoom trigger is a [data-open-dialog="zoom"] too, so
        // onDialogClose's focus fallback finds it by the same selector.
        this.openDialog(button.dataset.openDialog, button);
      } else if (button.hasAttribute('data-edit-selection')) {
        this.querySelector('[data-mount-options]')?.scrollIntoView({ block: 'center', behavior: 'auto' });
        this.querySelector('[data-mount][aria-pressed="true"]')?.focus({ preventScroll: true });
      } else if (button.hasAttribute('data-close-dialog')) {
        button.closest('dialog')?.close();
      } else if (button.hasAttribute('data-units')) {
        this.setQuantity(Number(button.dataset.units));
      } else if (button.hasAttribute('data-gallery-index')) {
        this.selectGallery(Number(button.dataset.galleryIndex));
      } else if (button.hasAttribute('data-sticky-add-to-cart')) {
        if (!this.changing && !this.sticky.disabled && !this.busy()) this.buy.click();
      } else if (button.hasAttribute('data-box-mount')) {
        this.explorerMount = button.dataset.boxMount;
        this.activeItemId = this.defaultItemFor(this.explorerMount);
        this.renderBoxTabs();
        this.renderBoxList();
        this.paintExplorer();
      } else if (button.hasAttribute('data-previous-item') || button.hasAttribute('data-next-item')) {
        this.stepExplorerItem(button.hasAttribute('data-next-item') ? 1 : -1);
      } else if (button.hasAttribute('data-item-id')) {
        this.selectExplorerItem(button.dataset.itemId);
      }
    }
  }
  customElements.define('bm-nano-configurator', NanoConfigurator);
})();
